<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      contentId="kycData"
      @dataAvailable="
        data => {
          kycData = data?.metaData || {}
        }
      "
    />
    <DataGetter
      @dataAvailable="
        data => {
          withdrawalAccounts = data?.metaData?.accounts
          this.accountsLoading = false
        }
      "
      contentId="withdrawalAccountsMomo"
    />

    <DataGetter
      @dataAvailable="
        data => {
          walletInfo = data?.metaData || {}
        }
      "
      contentId="walletInfo"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Transferts</div>
      <div>
        <button
          v-if="withdrawalAccounts.length > 0"
          @click="addNewAccount"
          class="buttonComponent"
        >
          Ajouter un compte
        </button>
      </div>
    </div>
    <div class="py-4"></div>
    <div class="sticky top-16 bg-[#f4f4f5] py-3 pt-6">
      <div class="flex justify-between items-center">
        <div
          class="w-full md:w-auto grid grid-cols-2 md:flex gap-4 p-1 bg-white rounded-2xl"
        >
          <button
            class="relative px-4 py-2 rounded-xl flex items-center justify-center"
            @click="activeTab = 'accounts'"
          >
            <div
              :class="{
                'w-full h-full bg-primary': activeTab == 'accounts',
                'w-0 h-0 bg-transparent': activeTab !== 'accounts',
              }"
              class="duration-300 absolute rounded-xl"
            ></div>
            <div
              class="relative"
              :class="{
                'text-white': activeTab == 'accounts',
                '': activeTab !== 'accounts',
              }"
            >
              Comptes de transferts
            </div>
          </button>
          <button
            class="relative px-4 py-2 rounded-xl flex items-center justify-center"
            @click="activeTab = 'transactions'"
          >
            <div
              :class="{
                'w-full h-full bg-primary': activeTab == 'transactions',
                'w-0 h-0 bg-transparent': activeTab !== 'transactions',
              }"
              class="duration-300 absolute rounded-xl"
            ></div>
            <div
              class="relative"
              :class="{
                'text-white': activeTab == 'transactions',
                '': activeTab !== 'transactions',
              }"
            >
              Transferts effectués
            </div>
          </button>
        </div>
      </div>
    </div>

    <div v-if="activeTab == 'transactions'">
      <DataGetter
        v-if="transactionsLoading"
        @dataAvailable="
          data => {
            if (!data?.metaData?.withdrawals) return
            totalPages = Math.ceil(data?.metaData?.total / 10)
            transactions = data?.metaData?.withdrawals
            this.transactionsLoading = false
          }
        "
        :searchQuery="{ page: currentPage, limit: 10 }"
        contentId="withdrawalsByMomo"
      />
      <div v-if="transactionsLoading || transactions.length > 0">
        <div class="py-4"></div>
        <div class="relative">
          <div class="w-full overflow-auto">
            <div>
              <div
                class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
              >
                <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                  Nom du compte
                </div>

                <div class="flex gap-6 w-[8rem] min-w-[8rem]">Montant</div>
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">Numéro</div>

                <div class="flex gap-6 w-[10rem] min-w-[10rem]">
                  Pays / Opérateur
                </div>

                <div class="flex gap-6 w-[10rem] min-w-[10rem]">
                  Date & Heure
                </div>

                <!-- Price and Quantity -->
                <div
                  class="flex gap-6 w-[8rem] min-w-[8rem] justify-center text-center pr-4"
                >
                  Status
                </div>
                <!-- <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  Actions
                </div> -->
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <div
                v-for="(withdrawal, index) in transactionsLoading
                  ? shimmerAccounts
                  : transactions"
                :key="index"
                class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
                :class="{ shimmerElement: withdrawal.shimmer }"
              >
                <div
                  class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
                ></div>
                <!-- Account Info -->
                <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                  <img
                    :src="withdrawal.withdrawalAccount?.image"
                    :class="{
                      'opacity-0': !withdrawal.withdrawalAccount?.image,
                    }"
                    class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                  />
                  <div class="w-[11rem]">
                    <h3 class="font-semibold title-color">
                      {{ withdrawal.withdrawalAccount?.fullName }}
                    </h3>
                  </div>
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  <div>{{ withdrawal.amount }}&nbsp;FCFA</div>
                </div>
                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  <div>
                    {{ withdrawal.withdrawalAccount?.metadata?.accountId }}
                  </div>
                </div>

                <!-- Price and Quantity -->
                <div class="w-[10rem] min-w-[10rem]">
                  {{
                    this.$Countries.find(
                      withdrawal.withdrawalAccount?.countryCode,
                    )?.countryName
                  }}
                  /
                  {{ withdrawal.withdrawalAccount?.metadata?.operator }}
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[10rem] min-w-[10rem]">
                  {{
                    withdrawal.date
                      ? $Commons.timestampToDate(
                          withdrawal.date,
                          'DD MMM YYYY hh[h] mm',
                        )
                      : '-'
                  }}
                </div>

                <!-- Price and Quantity -->
                <div
                  class="flex gap-6 w-[8rem] min-w-[8rem] justify-center pr-4"
                >
                  <button
                    class="whitespace-nowrap px-4 py-2 font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
                    :style="{
                      backgroundColor: statuses[withdrawal.status]?.background,
                      color: statuses[withdrawal.status]?.color,
                    }"
                  >
                    {{ statuses[withdrawal.status]?.name }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="py-2"></div>
        <div class="flex justify-center">
          <Pagination
            v-if="!transactionsLoading"
            :currentPage="currentPage"
            :totalPages="totalPages"
            @pageClick="newPage => (currentPage = newPage)"
          />
        </div>
      </div>
      <div
        class="h-[60vh] w-full flex-col items-center justify-center flex"
        v-else
      >
        <div class="w-1/5">
          <img src="@/assets/images/empty/exchange.png" alt="" />
        </div>
        <div class="py-1"></div>
        <div class="text-center">
          <div class="py-1"></div>
          <div class="text-4xl title-color font-bold">
            Aucun transfert effectué
          </div>
          <div class="py-1"></div>
          <div class="text-lg">
            Vos transferts mobile money apparaissent ici
          </div>
          <div class="py-3"></div>
          <div class="flex justify-center gap-6">
            <button @click="activeTab = 'accounts'" class="buttonComponent">
              Comptes de transfert
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="accountsLoading || withdrawalAccounts.length > 0">
        <div class="py-4"></div>
        <div class="relative">
          <div class="w-full overflow-auto">
            <div>
              <div
                class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
              >
                <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                  Nom du compte
                </div>

                <div class="flex gap-6 w-[8rem] min-w-[8rem]">Pays</div>

                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  Numéro Mobile Money
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  Opérateur Réseau
                </div>
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">Date d'ajout</div>

                <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  Actions
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <div
                v-for="(account, index) in accountsLoading
                  ? shimmerAccounts
                  : withdrawalAccounts"
                :key="index"
                class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
                :class="{ shimmerElement: account.shimmer }"
              >
                <div
                  class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
                ></div>
                <!-- Account Info -->
                <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                  <img
                    v-if="account.image"
                    :src="account.image"
                    class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                  />
                  <div class="w-[11rem]">
                    <h3 class="font-semibold title-color">
                      {{ account.fullName }}
                    </h3>
                  </div>
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  {{ this.$Countries.find(account?.countryCode)?.countryName }}
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  <div>{{ account.metadata?.accountId }}</div>
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  <div>{{ account.metadata?.operator }}</div>
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[8rem] min-w-[8rem]">
                  {{
                    $Commons.timestampToDate(
                      account.creationDate,
                      'DD MMM YYYY',
                    )
                  }}
                </div>

                <!-- SKU -->
                <!-- <div class=" text-gray-700">{{ account.sku }}</div> -->

                <!-- Actions -->
                <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  <DropdownComponent
                    :selects="[
                      {
                        name: 'Transférer vers le compte',
                        onClick() {
                          launchWithdraw(account)
                        },
                      },
                      {
                        name: 'Supprimer',
                        onClick() {
                          deleteAccount(account)
                        },
                      },
                    ]"
                    hideArrow
                    maxHeight="270px"
                    displayKey="name"
                    toLeft
                    :onSelect="
                      selected => {
                        selected.onClick()
                      }
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                      />
                    </svg>
                  </DropdownComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="h-[60vh] w-full flex-col items-center justify-center flex"
        v-else
      >
        <div class="w-1/5">
          <img src="@/assets/images/empty/exchange.png" alt="" />
        </div>
        <div class="py-1"></div>
        <div class="text-center">
          <div class="py-1"></div>
          <div class="text-4xl title-color font-bold">
            Aucun Compte de transfert
          </div>
          <div class="py-1"></div>
          <div class="text-lg">
            Ajoutez des comptes pour transférer votre argent vers un compte mobile money
          </div>
          <div class="py-3"></div>
          <div class="flex justify-center gap-6">
            <button @click="addNewAccount" class="buttonComponent">
              Créer un Compte
            </button>
          </div>
        </div>
      </div>
    </div>
    <AddNewWithdrawalAccount />
    <EventListener
      :events="[
        'withdrawal_account_deleted',
        'failed_to_delete_withdrawal_account',
        'withdrawal_launched',
        'failed_to_launch_withdrawal',
      ]"
      @withdrawal_account_deleted="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Compte supprimé',
            body: 'Le compte a été supprimé avec succès.',
          })
        }
      "
      @failed_to_delete_withdrawal_account="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Echec de supression du compte',
            body: 'La supression du compte a échoué. Veuillez réessayer',
          })
        }
      "
      @failed_to_launch_withdrawal="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Transfert non lancé',
            body: 'La création du transfert a échoué. Veuillez réessayer',
          })
        }
      "
      @withdrawal_launched="onWithdrawalLaunhced"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import AddNewWithdrawalAccount from './AddNewWithdrawalAccount.vue'
import Pagination from '../utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    EventListener,
    AddNewWithdrawalAccount,
    Pagination,
  },
  data() {
    return {
      eventsIds: [],
      withdrawalAccounts: [],
      transactionsLoading: true,
      totalPages: 0,
      currentPage: 1,
      transactions: [],
      walletInfo: {},
      kycData: {},
      accountsLoading: true,
      activeTab: 'accounts',
      shimmerAccounts: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],

      statuses: {
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paidWaiting: {
          id: 'pending',
          name: 'En cours',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    addNewAccount() {
      if (!this.kycData?.isValidated) {
        this.handleKycRequired()
        return
      }
      this.$Events.dispatchEvent('add_withdrawal_account', {
        accountTypeName: 'mobileMoney',
      })
    },
    handleKycRequired() {
      let routeToKyc = true
      let message =
        'Vous devez valider votre compte pour avoir accès aux transferts'
      if (this.kycData?.isPending || this.kycData?.isFilled) {
        routeToKyc = false
        message =
          'Veuillez patienter pendant la validation de votre compte pour créer des comtpes de transfert'
      } else if (this.kycData?.isRejected) {
        message =
          ' Votre compte a été rejeté, veuillez remplire à nouveau les informations'
      }
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Compte non validé',
        body: message,
      })
      if (routeToKyc) this.$router.push('/validation')
    },
    async deleteAccount(account) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment Supprimer le compte  ${account.name} ?`,
          subTitle: 'Vous ne pouvez plus retrouver ce compte',

          successText: 'Supprimer le compte',
          cancelText: 'Conserver le compte',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('withdrawal_account_deletion_requested', {
        id: account.id,
      })
    },
    async launchWithdraw(account) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Revercement vers le compte intitulé ${account.fullName} ?`,
          subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro mobile money: ${account.metadata?.accountId} <br/> Réseau: ${account.metadata?.operator} `,
          formFields: [
            {
              type: 'number',
              label: 'Montant à retirer',
              propertyName: 'amount',
              defaultValue: '',
              inputProps: {
                min: 200,
                max: this.walletInfo.balance,
              },
              required: true,
              class: '',
            },
          ],
          successText: 'Lancer',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('withdrawal_requested', {
        withdrawalAccount: account,
        amount: prompt.data.amount,
      })
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Création du transfert',
        body: 'La création du transfert est en cours',
      })
    },
    onWithdrawalLaunhced() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Transfert initié',
        body: "Le transfert a été initié, veuillez vérifier l'historique",
      })
    },
  },
  watch: {
    currentPage() {
      this.transactionsLoading = true
    },
    activeStatus() {
      this.transactionsLoading = true
      this.currentPage = 1
    },
  },
}
</script>
